import * as React from "react";
import { connect } from "react-redux";
import { FileTypeDisplay, MessageDirectionDisplay, MessageStatusDisplay } from "../../../../../store/Files/Displays";
import { FileFilters } from "../../../../../store/Files/Types";
import { MessageDirection, MessageStatus, MessageType } from "../../../../../store/Message/Types";
import { remoteClearError, remoteClearResponse, remoteTrigger } from "../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { validFromValidation, validTillValidation } from "@vwpfs/mary-air-lib/utils/FormValidations";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { clearFilters, updateFilters } from "../../../../../store/FilterActions";
import {
    FilterScope,
    getFilters,
    hasSearchableFilters,
} from "../../../../../store/FilterTypes";
import { ReduxState } from "../../../../../store/ReduxState";
import { ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { hasValueValidation } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field.utils";
import { ValidationStatus } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/_Types";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { Form } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

/**
 *
 */
type setFilterFn = (filters: Partial<FileFilters>) => void;
type clearFiltersFn = (filters?: Array<keyof FileFilters>) => void;

/**
 *
 */
interface OwnProps {
    loadingResults: boolean;
    defaultFilters?: FileFilters;
}

/**
 *
 */
interface StateProps {
    searchEnabled: boolean;
    filters: FileFilters;
}

/**
 *
 */
interface DispatchProps {
    setFilter: setFilterFn;
    clearFilters: clearFiltersFn;
    loadResults: () => void;
    clearResults: () => void;
}

interface State {
}

/**
 *
 */
type Props = OwnProps & StateProps & DispatchProps;

/**
 *
 */
export const mapStateToProps = (s: ReduxState, p: OwnProps): StateProps => ({
    searchEnabled: hasSearchableFilters(s, FilterScope.FILES, p.defaultFilters),
    filters: getFilters(s, FilterScope.FILES),
});

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    setFilter: (filters) => dispatch(updateFilters(filters, FilterScope.FILES)),
    clearFilters: (filters) => {
        dispatch(clearFilters(filters, FilterScope.FILES));
    },
    loadResults: () => dispatch(remoteTrigger(RemoteScope.FILES, { skip: 0 })),
    clearResults: () => (
        dispatch(remoteClearResponse(RemoteScope.FILES)),
        dispatch(remoteClearError(RemoteScope.FILES))
    ),
});

/**
 *
 * @param props
 */
export class FilterComp
    extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {};
        this.nameValidation = this.nameValidation.bind(this);
        this.typeValidation = this.typeValidation.bind(this);
        this.statusValidation = this.statusValidation.bind(this);
        this.directionValidation = this.directionValidation.bind(this);
        this.fromDateValidation = this.fromDateValidation.bind(this);
        this.toDateValidation = this.toDateValidation.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);
        this.onChangeDirection = this.onChangeDirection.bind(this);
        this.onChangeFromDate = this.onChangeFromDate.bind(this);
        this.onChangeToDate = this.onChangeToDate.bind(this);
        this.initFilters = this.initFilters.bind(this);
    }

    public componentDidMount() {
        this.initFilters();
    }

    public componentWillUnmount() {
        this.props.clearResults();
    }

    public render() {
        return (
            <Form onSubmit={this.onSearchFilter}>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 6 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            label="Name"
                            onChange={this.onChangeName}
                            value={this.props.filters?.name ?? ""}
                            validationFunction={this.nameValidation}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 6 }}
                    >
                        <FormField
                            type={FieldTypes.Select}
                            label="Type"
                            onChange={this.onChangeType}
                            value={
                                this.props.defaultFilters?.type
                                    ? this.props.defaultFilters.type :
                                    this.props.filters && this.props.filters.type}
                            placeholder="Make a choice"
                            options={Object.keys(MessageType).map((p) => ({
                                label: FileTypeDisplay[p] as string,
                                value: p,
                            }))}
                            validationFunction={this.typeValidation}
                        />
                    </Grid>
                </Div>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 6 }}
                    >
                        <FormField
                            type={FieldTypes.Select}
                            label="Status"
                            onChange={this.onChangeStatus}
                            value={
                                this.props.defaultFilters?.status
                                    ? this.props.defaultFilters.status :
                                    this.props.filters && this.props.filters.status}
                            placeholder="Make a choice"
                            options={Object.keys(MessageStatus).map((p) => ({
                                label: MessageStatusDisplay[p] as string,
                                value: p,
                            }))}
                            validationFunction={this.statusValidation}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 6 }}
                    >
                        <FormField
                            type={FieldTypes.Select}
                            label="Direction"
                            onChange={this.onChangeDirection}
                            value={
                                this.props.defaultFilters?.direction
                                    ? this.props.defaultFilters.status :
                                    this.props.filters && this.props.filters.direction}
                            placeholder="Make a choice"
                            options={Object.keys(MessageDirection).map((p) => ({
                                label: MessageDirectionDisplay[p] as string,
                                value: p,
                            }))}
                            validationFunction={this.directionValidation}
                        />
                    </Grid>
                </Div>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 6 }}
                    >
                        <FormField
                            label="Creation date from"
                            onChange={this.onChangeFromDate}
                            type={FieldTypes.Date}
                            value={this.props.filters?.creationDateFrom ?? ""}
                            validationFunction={this.fromDateValidation}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 6 }}
                    >
                        <FormField
                            label="Creation date to"
                            onChange={this.onChangeToDate}
                            type={FieldTypes.Date}
                            value={this.props.filters?.creationDateTo ?? ""}
                            validationFunction={this.toDateValidation}
                        />
                    </Grid>
                </Div>
                <ButtonsWrapper alignment={Alignment.CENTER} defaultOrientation={Orientation.HORIZONTAL}>
                    <Button
                        className="scl-a-btn--big scl-a-btn scl-a-btn--brand-link"
                        link={{ onClick: this.initFilters }}
                        disabled={!this.props.searchEnabled || this.props.loadingResults}
                    >
                        Clear filters
                    </Button>
                    {" "}
                    <Button
                        theme={{ palette: ThemePalette.BRAND_ACCENT }}
                        className="scl-a-btn--big"
                        buttonType="submit"
                        disabled={this.props.loadingResults}
                    >
                        Search
                    </Button>
                </ButtonsWrapper>
            </Form>
        );
    }

    private nameValidation(value: string | number) {
        return hasValueValidation(
            value.toString(),
            "Name provided",
        );
    }

    private typeValidation(value: string | number) {
        return hasValueValidation(
            value.toString(),
            "Type provided",
        );
    }

    private statusValidation(value: string | number) {
        return hasValueValidation(
            value.toString(),
            "Status provided",
        );
    }

    private directionValidation(value: string | number) {
        return hasValueValidation(
            value.toString(),
            "Direction provided",
        );
    }

    private fromDateValidation(value: string | number) {
        if (this.props?.filters.creationDateFrom && this.props?.filters.creationDateTo) {
            return validFromValidation(value.toString(),
                this.props.filters.creationDateTo);
        } else {
            return {
                status: ValidationStatus.ERROR,
                message: "You have to provide a to date",
            };
        }
    }

    private toDateValidation(value: string | number) {
        if (this.props?.filters.creationDateFrom && this.props?.filters.creationDateTo) {
            return validTillValidation(value.toString(),
                this.props.filters.creationDateFrom);
        } else {
            return {
                status: ValidationStatus.ERROR,
                message: "You have to provide a from date",
            };
        }
    }

    private onChangeName(value?: string | number) {
        return this.onChange("name", value?.toString() ?? "");
    }

    private onChangeType(value?: string | number) {
        return this.onChange("type", value ? value.toString() as MessageType : undefined);
    }

    private onChangeStatus(value?: string | number) {
        return this.onChange("status", value ? value.toString() as MessageStatus : undefined);
    }

    private onChangeDirection(value?: string | number) {
        return this.onChange("direction", value ? value.toString() as MessageDirection : undefined);
    }

    private onChangeFromDate(value?: string | number) {
        return this.onChange("creationDateFrom", value?.toString() ?? "");
    }

    private onChangeToDate(value?: string | number) {
        return this.onChange("creationDateTo", value?.toString() ?? "");
    }

    private initFilters() {
        this.clearFilters();
        if (this.props.defaultFilters) {
            this.props.setFilter(this.props.defaultFilters);
        }
        this.props.loadResults();
    }

    private clearFilters = () => {
        const filters =
            (Object.keys(this.props.filters ?? {}) as Array<keyof FileFilters>);

        this.props.clearFilters(filters);
    };

    private onChange = <K extends keyof FileFilters>(key: K, value: FileFilters[K]) => {
        this.props.setFilter({
            [key]: value,
        });
    };

    private onSearchFilter = () => {
        this.props.loadResults();
    };
}

/**
 *
 */
export const Filter = connect(
    mapStateToProps,
    mapDispatchToProps,
)(FilterComp);
